const DOCUMENT = 'ADD_ACCREDITATION_';

const actions = {
  LOAD_DATA_REQUEST: DOCUMENT + 'LOAD_DATA_REQUEST',
  LOAD_DATA_SUCCESS: DOCUMENT + 'LOAD_DATA_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  CREATE_DATA_REQUEST: DOCUMENT + 'CREATE_DATA_REQUEST',
  CREATE_DATA_SUCCESS: DOCUMENT + 'CREATE_DATA_SUCCESS',
  CREATE_DATA_ERROR: DOCUMENT + 'CREATE_DATA_ERROR',
  TOUCH: DOCUMENT + 'TOUCH',

  loadFormDataRequest: data => ({
    type: actions.LOAD_DATA_REQUEST,
    payload: data,
  }),

  loadFormDataSuccess: data => ({
    type: actions.LOAD_DATA_SUCCESS,
    payload: data,
  }),

  createAccreditationRequest: data => ({
    type: actions.CREATE_DATA_REQUEST,
    payload: data,
  }),

  createAccreditationSuccess: data => ({
    type: actions.CREATE_DATA_SUCCESS,
    payload: data,
  }),

  createAccreditationError: data => ({
    type: actions.CREATE_DATA_ERROR,
    payload: data,
  }),

  changeProperty: data => ({
    type: actions.CHANGE_PROPERTY,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),

  touch: data => ({
    type: actions.TOUCH,
    payload: data,
  }),
};

export default actions;
